import { CWBClient } from "../../client";

export const createUploadAndProcessAPI = (clientId, formData) => {
  return CWBClient.post(
    `${process.env.REACT_APP_API_PM_BASE_PATH || ''}/PitchReel/${clientId}/composition/create-upload-and-process`,
    formData
  );
};
